import { Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { Add as AddIcon } from "@material-ui/icons";
import React from "react";
import styled from "styled-components";
import { observer } from "mobx-react";
import { useStores } from "../../../../../hooks";
import { MenuFormType } from "../../../store/menu/forms";
import { Paper } from "../../../../../common/components/libs";
import {Trans, useTranslation} from "react-i18next";


const Wrapper = styled(Paper)`
  padding: ${
    props => {
        return props.theme.spacing(6)
    }}px;

  ${props => props.theme.breakpoints.up("md")} {
    padding: ${props => props.theme.spacing(10)}px;
  }
`;


const NoModifiersSets = () => {
    const {menuStore} = useStores();
    const {t} = useTranslation(["general", "menu"]);
    return <div style={{maxWidth: 500}}>
        <Wrapper>
            <Typography component="h1" variant="h4" align="center" gutterBottom>
                {t("menu:modifiersSet.addFirstModifier")}
            </Typography>
            <Typography component="h4" variant="body2" align="center" gutterBottom>
                {t("menu:modifiersSet.modifierDescription")}
                <br/>
                {t("menu:modifiersSet.exampleSizePizzaOrSyrup")}
            </Typography>
            <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
                <Button variant="contained"
                        color="primary"
                        onClick={() => {
                            menuStore.forms.showPopupForm(MenuFormType.editMenuModifiersSet)
                        }}
                >
                    <AddIcon/>
                    {t("general:add")}
                </Button>
            </div>

        </Wrapper>
    </div>
};


export default observer(NoModifiersSets)
